import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[appBackgroundImage]',
    standalone: false
})
export class BackgroundImageDirective implements OnInit {

  @Input('appBackgroundImage') private appBackgroundImage: string;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngOnInit() {
    this.renderer.setStyle(this.elementRef.nativeElement, 'backgroundImage', 'url(' + this.appBackgroundImage + ')');
  }

}
